// extracted by mini-css-extract-plugin
export var container = "FeatureWithMediaAside-module--container--11e6c";
export var content_column = "FeatureWithMediaAside-module--content_column--49322";
export var media = "FeatureWithMediaAside-module--media--6e14f";
export var media_column = "FeatureWithMediaAside-module--media_column--6130d";
export var media_position_left = "FeatureWithMediaAside-module--media_position_left--e5021";
export var media_position_right = "FeatureWithMediaAside-module--media_position_right--8daaa";